import MuiTextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

const TextField = styled(MuiTextField)({
  "& .MuiInputBase-root": {
    paddingLeft: "4px",
  },

  "& .MuiInputBase-input": {
    padding: "8px 4px",
    background: "white",
    borderRadius: "8px",
    fontSize: "13px",
  },

  "& fieldset": {
    borderRadius: "8px",
    border: "1px solid #A0A0A0",

    "& legend": {
      fontSize: "14px",
    },
  },

  "& .MuiFormLabel-root": {
    fontSize: "18px",
    color: "#3961A0",
  },
});

export default TextField;
